import { useEffect } from 'react'
import { App as AntdApp, ConfigProvider, ThemeConfig } from 'antd'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './App.css'
import { useMainStates } from './components/state'
import Menu from './Menu'
import Login from './pages/login'
import Main from './pages/main'
import CasinoModelView from "./pages/casino-model";
import CasinoSettingsView from "./pages/casino-settings";
import {userService} from "./components/api";
import {MeResponse} from "./api/ga/config_manager/user/user_admin_pb";
import CasinoKeys from "./pages/casino-keys";
import ServiceConfigDeployment from "./pages/service-config-deployment";
import ProviderModelView from "./pages/provider-model";
import ProviderSettingsView from "./pages/provider-settings";
import {UserScope} from "./api/ga/bo/user_scope/user_scope_pb";

// Theme derived from the SOFTSWISS "a8r-uikit" design system tokens (see theme.css).
// Keeps antd components (buttons, selects, inputs, tables, modals) on-brand.
const theme: ThemeConfig = {
  token: {
    colorPrimary: '#ec544f', // SOFTSWISS red
    colorInfo: '#4d93fb', // action blue
    colorSuccess: '#69a276',
    colorWarning: '#d2a942',
    colorError: '#c52e2e',
    colorLink: '#ec544f',
    colorLinkHover: '#ec544fb8',
    borderRadius: 4,
    fontFamily:
      "'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
  },
}

export default function App() {
  const { userScope, setUserScope } = useMainStates((state) => state)

  useEffect(() => {
    userService
      .me({})
      .then((resp: MeResponse) =>
        setUserScope(resp?.scope ? resp.scope : ({} as UserScope))
      )
      .catch((e) => {
        console.log(e)
        setUserScope({} as UserScope)
      })
  }, [setUserScope])

  const auth = userScope?.userId ?? ''

  return (
    <ConfigProvider theme={theme}>
      <AntdApp className="App">
        {!auth && <Login />}
        {auth && (
          <>
            <BrowserRouter basename="/lab">
              <Menu />
              <Routes>
                <Route path="/" element={<CasinoKeys />} />
                <Route path="/casino_keys" element={<CasinoKeys />} />
                <Route path="/casino_model" element={<CasinoModelView />} />
                <Route path="/casino_setting" element={<CasinoSettingsView />} />
                <Route path="/provider_model" element={<ProviderModelView />} />
                <Route path="/provider_setting" element={<ProviderSettingsView />} />
                <Route path="/service_config_deployment" element={<ServiceConfigDeployment />} />
              </Routes>
            </BrowserRouter>
          </>
        )}
      </AntdApp>
    </ConfigProvider>
  )
}
